import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

const useStyles = makeStyles(fillInTheBlanksStyles)

export default function FillInTheBlanks ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const {translate, quizAssessmentToTake: assessment, assessment: assessmentId} = context

  const answer = assessment.answers[question.id] || {}
  const {phrases = []} = answer

  function handlePhraseChange (index, phrase) {
    const completed = phrase.length == 0 ? false : phrases.every(({phrase, blanked},i) => i == index || !blanked || phrase.length > 0)
    context.updateState({quizAssessmentToTake: {
      answers: {
        [question.id]: {
          phrases: {[index]: {phrase: {$set: phrase}}},
          completed: {$set: completed}
        }}}})
  }

  function handleOnBlur() {
    context.saveAnswers({id: assessmentId, answers: assessment.answers})
  }
	
  return (<Box className={classes.root}>
    {phrases.map(({phrase, blanked}, index) =>
      blanked
        ? (<input
          key={index}
          className={clsx(classes.input, classes.phrase)}
          type="text"
          value={phrase}
          onChange={e => handlePhraseChange(index, e.target.value)}
          onBlur={handleOnBlur}
          />)
        : (<Box
          key={index}
          className={classes.phrase}>{phrase}</Box>)
    )}
  </Box>)
}


function fillInTheBlanksStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      padding: '35px 0',
      fontSize: '12pt',
    },
    phrase: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginRight: 10,
      '&:last-child': {
        marginLeft: 0
      }
    },
    input: {
        border: 'none',
        borderBottom: 'solid 1px black',
    },
  }
}
